import { request } from '../../..';
import { IRecordCategoryNodesVisibilityRequest } from '../../../indigofair/category/IRecordCategoryNodesVisibilityRequest';
import { IRecordCategoryNodesVisibilityResponse } from '../../../indigofair/category/IRecordCategoryNodesVisibilityResponse';
import {
  EndpointOptions,
  RequestOptions,
  SuccessResponse,
  PATH,
} from '../../../types';

export const path = () => {
  return `/api/category/record-category-nodes-visibility`;
};

export const build = (
  data: IRecordCategoryNodesVisibilityRequest,
  options?: EndpointOptions
): RequestOptions & { route: string } => {
  return {
    route,
    url: path(),
    method: 'POST',
    data,
    ...options,
    headers: {
      'content-type': 'application/json',
      ...options?.headers,
    },
  };
};
/**
 * path-to-regexp definition of this endpoint's route
 */
export const route = '/api/category/record-category-nodes-visibility';

/**
 * Endpoint used for clients to report that certain category/navigation tree nodes are now visible to the user.
 * Used currently for A/B testing bucketing purposes.
 * Product Area: NAVIGATION_TREE_UX
 */
export function execute(
  data: IRecordCategoryNodesVisibilityRequest
): Promise<IRecordCategoryNodesVisibilityResponse>;
export function execute(
  data: IRecordCategoryNodesVisibilityRequest,
  options?: EndpointOptions & { rawResponse: true }
): Promise<SuccessResponse<IRecordCategoryNodesVisibilityResponse>>;
export function execute(
  data: IRecordCategoryNodesVisibilityRequest,
  options?: EndpointOptions
): Promise<IRecordCategoryNodesVisibilityResponse>;
export function execute(
  data: IRecordCategoryNodesVisibilityRequest,
  options?: EndpointOptions
): Promise<
  | IRecordCategoryNodesVisibilityResponse
  | SuccessResponse<IRecordCategoryNodesVisibilityResponse>
> {
  const { route, ...requestOptions } = build(data, options);
  return request<IRecordCategoryNodesVisibilityResponse>(requestOptions);
}
execute[PATH] = 'api/category/record-category-nodes-visibility/post';
export default execute;
